function AboutMission({ onLearnMoreClick }) {
    try {
        return (
            <section data-name="about-mission" className="section py-24 bg-gray-800 relative overflow-hidden">
                {/* Background elements */}
                <div className="absolute inset-0">
                    <div className="absolute top-0 left-0 w-full h-full">
                        <div className="absolute w-96 h-96 rounded-full bg-green-500/10 blur-3xl -top-48 -left-48"></div>
                        <div className="absolute w-96 h-96 rounded-full bg-blue-500/10 blur-3xl bottom-0 right-0"></div>
                    </div>
                </div>
                
                <div className="container relative z-10">
                    <div className="max-w-6xl mx-auto">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                            <div className="relative">
                                <div className="relative rounded-xl overflow-hidden shadow-2xl">
                                    <img 
                                        src="https://images.unsplash.com/photo-1495592822108-9e6261896da8?crop=entropy&cs=srgb&fm=jpg&ixid=M3wzMjA0NjB8MHwxfHNlYXJjaHwxMHx8Z3JlZW4lMjB0ZWNofGVufDB8fHx8MTc0Mjk3MDY1OXww&ixlib=rb-4.0.3&q=85" 
                                        alt="Sustainable Computing" 
                                        className="w-full h-full object-cover"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent"></div>
                                    <div className="absolute bottom-0 left-0 p-6">
                                        <div className="inline-block bg-green-500 text-white px-4 py-2 rounded-lg font-bold text-sm mb-3">
                                            Our Mission
                                        </div>
                                        <h3 className="text-2xl font-bold text-white mb-2">Bridging the Digital Divide</h3>
                                    </div>
                                </div>
                                
                                {/* Decorative elements */}
                                <div className="absolute -bottom-8 -right-8 w-40 h-40 border-4 border-green-500/30 rounded-xl -z-10"></div>
                                <div className="absolute -top-8 -left-8 w-24 h-24 bg-green-500/20 rounded-xl -z-10"></div>
                            </div>
                            
                            <div>
                                <h2 className="text-4xl font-bold mb-8 text-white">
                                    About Our <span className="text-green-400">Mission</span>
                                </h2>
                                
                                <p className="text-gray-300 text-lg mb-6 leading-relaxed">
                                    Sustainable Compute Network transforms e-waste into high-performance computing solutions powered by renewable energy. Our dual-entity model combines charitable outreach with sustainable hardware renewal to democratize access to technology.
                                </p>
                                
                                <div className="space-y-6 mb-8">
                                    <div className="flex items-start">
                                        <div className="bg-green-500/20 text-green-400 p-3 rounded-lg mr-4 flex-shrink-0">
                                            <i className="fas fa-recycle text-xl"></i>
                                        </div>
                                        <div>
                                            <h3 className="font-bold text-white text-lg">E-Waste Transformation</h3>
                                            <p className="text-gray-400">Refurbishing discarded hardware into powerful computing resources</p>
                                        </div>
                                    </div>
                                    
                                    <div className="flex items-start">
                                        <div className="bg-green-500/20 text-green-400 p-3 rounded-lg mr-4 flex-shrink-0">
                                            <i className="fas fa-solar-panel text-xl"></i>
                                        </div>
                                        <div>
                                            <h3 className="font-bold text-white text-lg">Renewable Energy Powered</h3>
                                            <p className="text-gray-400">Solar and wind-powered infrastructure for carbon-neutral operations</p>
                                        </div>
                                    </div>
                                    
                                    <div className="flex items-start">
                                        <div className="bg-green-500/20 text-green-400 p-3 rounded-lg mr-4 flex-shrink-0">
                                            <i className="fas fa-users text-xl"></i>
                                        </div>
                                        <div>
                                            <h3 className="font-bold text-white text-lg">Equitable Access</h3>
                                            <p className="text-gray-400">Free computing resources for underprivileged students and researchers</p>
                                        </div>
                                    </div>
                                </div>
                                
                                <button 
                                    onClick={onLearnMoreClick}
                                    className="btn btn-primary inline-flex items-center"
                                >
                                    Learn More About Us
                                    <i className="fas fa-arrow-right ml-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    } catch (error) {
        console.error('AboutMission error:', error);
        reportError(error);
        return null;
    }
}

window.AboutMission = AboutMission;

export default AboutMission;
